import React, { Fragment, useEffect } from 'react';
import { Avatar, IconButton, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import FlagEn from '@assets/images/flag/icon-flag-en.svg';
import FlagVn from '@assets/images/flag/icon-flag-vn.svg';
import { Popover } from 'antd';

import { Stack } from '@mui/system';

import { onSetLanguage } from '@store/common/actions';
import { getLanguageSelector } from '@store/common/selector';

const Languages = [
  {
    flagname: 'English',
    icon: FlagEn,
    value: 'en',
  },
  {
    flagname: 'Tiếng Việt',
    icon: FlagVn,
    value: 'vi',
  },
];

const Language = ({ style, styleAvatar, styleIcon }) => {
  const dispatch = useDispatch();
  const lang = useSelector(getLanguageSelector);

  const currentLang = Languages?.find((_lang) => _lang.value === lang) || Languages[1];

  useEffect(() => {
    if (lang) {
      dispatch(onSetLanguage(lang));
    }
  }, [lang]);

  const content = (
    <div>
      {Languages?.map((option, index) => (
        <div
          key={index}
          onClick={() => dispatch(onSetLanguage(option.value))}
          style={{
            padding: '10px',
            cursor: 'pointer',
            backgroundColor: option.value === lang ? '#f0f0f0' : '#fff',
          }}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <Avatar
              src={option.icon}
              alt={option.icon}
              sx={{ width: 20, height: 20, ...styleAvatar }}
            />
            <Typography> {option.flagname}</Typography>
          </Stack>
        </div>
      ))}
    </div>
  );

  return (
    <>
      <Popover
        content={content}
        trigger="click"
        placement="bottomRight"
        overlayInnerStyle={{
          width: '200px',
        }}
      >
        <IconButton
          size="medium"
          aria-label="more"
          id="long-button"
          aria-haspopup="true"
          style={styleIcon}
        >
          <Avatar
            src={currentLang.icon}
            alt={currentLang.value}
            sx={{ width: 20, height: 20, ...style }}
          />
        </IconButton>
      </Popover>
    </>
  );
};

export default Language;
